import ArrowSq from '@alltrails/denali/icons/ArrowSq';
import Typography from '@alltrails/core/components/Typography';
import LinkButtonOrDiv from '@alltrails/denali/components/LinkButtonOrDiv';
import styles from './styles/styles.module.scss';

type ActionRowProps = {
  label: string;
  onClick: (name: string) => void;
};

export default function ActionRow({ label, onClick }: ActionRowProps) {
  return (
    <LinkButtonOrDiv className={styles.row} onClick={() => onClick(label)} testId={`report-${label}-action`}>
      <Typography component="div" variant="text200">
        {label}
      </Typography>
      <ArrowSq size="md" orientation="right" color="--color-text-secondary" />
    </LinkButtonOrDiv>
  );
}
